import fontawesome from '@fortawesome/fontawesome'

import {
    // -- Arrows -
    // faAngleUp,
    // faAngleRight,
    // faAngleDown,
    // faAngleLeft,
    // faAngleDoubleUp,
    // faAngleDoubleRight,
    // faAngleDoubleDown,
    // faAngleDoubleLeft,
    // faChevronUp,
    faChevronRight,
    // faChevronDown,
    faChevronLeft,
    // faChevronDoubleUp,
    // faChevronDoubleRight,
    // faChevronDoubleDown,
    // faChevronDoubleLeft,
    // -- Contact -
    // faPhone,
    // faEnvelope,
    // -- Common -
    // faHome,
    // faSearch,
    // faPlay,
    // faPlus,
    // -- Misc -
    // faUser,
    // faUserAlt,
    // faCogs,
    // faComment,
    // faDownload,
    // faFile,
    // faFilePdf,
    // faInfo,
    // faInfoCircle,
    // faLink,
    // faExternalLink,
    // faExpandAlt,
    // faLocationArrow,
    // faMapMarker,
    // faMapMarkerAlt,
    // faMapSigns,
    // faHeart
} from '@fortawesome/fontawesome-pro-light'

fontawesome.library.add(
    // -- Arrows -
    // faAngleUp,
    // faAngleRight,
    // faAngleDown,
    // faAngleLeft,
    // faAngleDoubleUp,
    // faAngleDoubleRight,
    // faAngleDoubleDown,
    // faAngleDoubleLeft,
    // faChevronUp,
    faChevronRight,
    // faChevronDown,
    faChevronLeft,
    // faChevronDoubleUp,
    // faChevronDoubleRight,
    // faChevronDoubleDown,
    // faChevronDoubleLeft,
    // -- Contact -
    // faPhone,
    // faEnvelope,
    // -- Common -
    // faHome,
    // faSearch,
    // faPlay,
    // faPlus,
    // -- Misc -
    // faUser,
    // faUserAlt,
    // faCogs,
    // faComment,
    // faDownload,
    // faFile,
    // faFilePdf,
    // faInfo,
    // faInfoCircle,
    // faLink,
    // faExternalLink,
    // faExpandAlt,
    // faLocationArrow,
    // faMapMarker,
    // faMapMarkerAlt,
    // faMapSigns,
    // faHeart
)



// WEBPACK FOOTER //
// ./themes/base/js/fontawesome/light.js